import { createContext, useEffect } from 'react';
// redx
import { useDispatch, useSelector } from 'react-redux';
// hook useSocket
import { useSocket } from '../hooks/useSocket'
import { actualizarActivoSeccion } from '../store/slices/seccion';
// import { actualizarActivoSeccion, actualizarDBSeccion, actualizarEstadisticaSeccion } from '../store/slices/curso';
import { setUsuarios } from '../store/slices/usuario';

export const SocketContext = createContext();

export const SocketProvider = ({ children }) => {

    const dispatch = useDispatch();

    const { usuario } = useSelector(store => store.usuario);
    const { curso } = useSelector(store => store.curso);
    const { socket, online, conectarSocket, desconectarSocket } = useSocket(process.env.REACT_APP_SOCKET);

    useEffect(() => {
        if (usuario.uid !== '' && curso.cid !== '') {
            console.log('Usuario conectado')
            const { cursos } = usuario; 
            const cursoUsuario = cursos.find(item => item.cid === curso.cid);
            conectarSocket({cid: cursoUsuario.cid, grupo: cursoUsuario.grupo})
        }
    }, [usuario, curso, conectarSocket])

    useEffect(() => {
        if (usuario.uid === '' || curso.cid === '') {
            console.log('Usuario desconectado')
            desconectarSocket()
        }
    }, [usuario, curso, desconectarSocket])

    // Escucha actualización de activo-seccion: true o false
    useEffect(() => {
        socket?.on('actualizar-activo-seccion', (seccionActivoActualizado) => {
            console.log('actualizar-activo-seccion')
            dispatch(actualizarActivoSeccion(seccionActivoActualizado))
        })
    }, [socket, dispatch])














    // Escuchar actualización de activo: true o false, en la sección.
    useEffect(() => {
        // socket?.on('seccion-actualizada', (seccionActualizada) => {
        //     console.log('seccion-actualizada')
        //     dispatch(actualizarActivoSeccion(seccionActualizada))
        // })
    }, [socket, dispatch])

    // Escuchar actualización del estado: true o false, de un ejercicio en la sección.
    useEffect(() => {
        // console.log('Hola 2')
        // socket?.on('ejercicio-seccion-actualizado', (dbSeccionActualizada) => {
        //     dispatch(actualizarDBSeccion(dbSeccionActualizada))
        // })
    }, [socket, dispatch])

    // Escuchar actualización de la estadistica de una sección
    useEffect(() => {
        // console.log('Hola 3')
        // socket?.on('estadistica-seccion', (estadistica) => {
        //     dispatch(actualizarEstadisticaSeccion(estadistica))
        // })
    }, [socket, dispatch])

    // Escuchar actualización de usuarios en sala
    useEffect(() => {
        socket?.on('usuarios-sala', (usuarios) => {
            dispatch(setUsuarios(usuarios))
        })
    }, [socket, dispatch])
    
    
    return (
        <SocketContext.Provider value={{ socket, online }}>
            { children }
        </SocketContext.Provider>
    )
}